"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _reactImage = require("react-image");
var _Link = _interopRequireDefault(require("../Link"));
var _index = _interopRequireDefault(require("./index.style"));
var _DefaultCarrier = _interopRequireDefault(require("../Icons/DefaultCarrier"));
const CardSummary = _ref => {
  let {
    className = '',
    kind = 'Departing',
    date = 'Fri, Sep 3, 2021',
    departureAirport = 'ATL',
    arrivalAirport = 'MIA',
    departureTime = '5:55 AM',
    arrivalTime = '7:50 AM',
    overnight = '+1',
    flightDuration = '1h 55m',
    confirmationLabel = 'Confirmation number ',
    confirmationNumbers = ['UA-3JYGFR', 'AA-JDK989'],
    children,
    linkHref,
    linkText = 'View details',
    summaryTitle = 'Passengers',
    passengers = '',
    carrier = {
      name: 'Delta',
      logo: '',
      flightNumber: 'DL2732',
      operatedBy: 'Delta',
      layover: 'Nonstop',
      class: 'Economy'
    }
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(classes.rootCardSummary, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_reactImage.Img, {
    src: carrier.logo,
    alt: carrier.name,
    unloader: /*#__PURE__*/_react.default.createElement(_DefaultCarrier.default, null)
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h3"
  }, kind, " \u2014 ", date)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "confirmation"
  }, Array.isArray(confirmationNumbers) && confirmationNumbers.length > 0 && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, confirmationLabel, ": ", Array.from(confirmationNumbers).join(', '))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "detailsLink"
  }, linkText !== '' && /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: linkHref
  }, linkText)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "timeDetails"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, /*#__PURE__*/_react.default.createElement("span", null, departureTime, " \u2014 ", arrivalTime, " ", /*#__PURE__*/_react.default.createElement("sup", null, overnight)))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "details"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, /*#__PURE__*/_react.default.createElement("span", null, departureAirport, " \u2014 ", flightDuration, " \u2014 ", arrivalAirport), /*#__PURE__*/_react.default.createElement("span", null, carrier.layover), /*#__PURE__*/_react.default.createElement("span", null, carrier.operatedBy), /*#__PURE__*/_react.default.createElement("span", null, carrier.class))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "flightNumber"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, carrier.flightNumber)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "passengers"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, /*#__PURE__*/_react.default.createElement("span", null, summaryTitle), passengers && /*#__PURE__*/_react.default.createElement("span", null, passengers))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: "divider"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, null, children));
};
var _default = exports.default = CardSummary;